import * as React from 'react';
import * as ReactModal from 'react-modal';
import { Modal as BootstrapModal } from "react-bootstrap/lib";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
    },
};

const ReactModalWithStyle = (props) => {
    // @ts-ignore
    return <ReactModal
        {...props}
        style={customStyles}
    >
        {/* @ts-ignore */}
        {props.modalHeader ? <BootstrapModal.Header>{props.modalHeader}</BootstrapModal.Header> : null}

        {/* @ts-ignore */}
        <BootstrapModal.Body>{props.children}</BootstrapModal.Body>

        {/* @ts-ignore */}
        {props.modalFooter ? <BootstrapModal.Footer>{props.modalFooter}</BootstrapModal.Footer> : null}
    </ReactModal>
}

export default ReactModalWithStyle;